import { cartStore } from '../components'
import { CONFIG } from '../config'
import { IShopifyCartUpdates, IShopifyLineItem } from '../interfaces'
import { KeyVal } from '../types'
import { HTTPService } from './http.service'

class ShopifyCartService extends HTTPService {
  endpoint: KeyVal<string> = {
    clear: `${CONFIG.shopify.cartEndpoint}/clear.js`,
    update: `${CONFIG.shopify.cartEndpoint}/update.js`,
    add: `${CONFIG.shopify.cartEndpoint}/add.js`
  }

  async updateQuantity(id: number, quantity: number): Promise<any | null> {
    try {
      const response = await this.post(this.endpoint.update, {
        updates: {
          [id]: quantity
        }
      })

      return response
    } catch (e) {
      // @TODO Log to Sentry
      return null
    }
  }

  async updateQuantityItems(payload: { [key: string]: number }): Promise<any | null> {
    try {
      const response = await this.post(this.endpoint.update, {
        updates: payload
      })

      return response
    } catch (e) {
      // @TODO Log to Sentry
      return null
    }
  }

  async addToCart(id: number, quantity: number): Promise<any | null> {
    try {
      const response = await this.post(this.endpoint.add, {
        items: [
          {
            id,
            quantity
          }
        ],
        attributes: {
          delivery_day: cartStore.deliveryDate,
          delivery_time: cartStore.deliveryTime,
          delivery_week: cartStore.deliveryWeek,
          shipping_method: cartStore.shippingMethod
        }
      })

      return response
    } catch (e) {
      // @TODO Log to Sentry
      return null
    }
  }

  async createCart(items: IShopifyLineItem[]): Promise<any | null> {
    try {
      // Clear the cart first, to ensure we remove any previous instances
      await this.post(this.endpoint.clear, {})
      // Post the current cart from state to Shopify
      const response = await this.post(this.endpoint.add, {
        items,
        attributes: {
          delivery_day: cartStore.deliveryDate,
          delivery_time: cartStore.deliveryTime,
          delivery_week: cartStore.deliveryWeek,
          shipping_method: cartStore.shippingMethod
        }
      })

      return response
    } catch (e) {
      // @TODO Log to Sentry
      return null
    }
  }
}

export const shopifyCartService = new ShopifyCartService()
